import Box from 'components/Box';
import Button from 'components/Button';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
type IPrintHeaderProps = {
  onBack: () => void;
  onPrint: () => void;
};

const CreditCardDailyPrintHeader = ({ onBack, onPrint }: IPrintHeaderProps) => {
  return (
    <PrintHeaderStyled>
      <Text variant='H1' color='text_3' className='header-print'>
        DAILY BATCH REPORT PREVIEW
      </Text>
      <Box display='flex' gap='3'>
        <Button cardCashier ntype='SECONDARY' icon='back' onClick={onBack}>
          Back
        </Button>
        <Button cardCashier ntype='SECONDARY' icon='print' onClick={onPrint}>
          Print
        </Button>
      </Box>
    </PrintHeaderStyled>
  );
};

export default CreditCardDailyPrintHeader;

const PrintHeaderStyled = styled.div`
  width: calc(100% - 2rem);
  padding: 1rem;
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Poppins;

  .header-print {
    font-weight: 500;
  }

  .CONTENT_2 {
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
    line-height: 1;
  }
`;
